// extracted by mini-css-extract-plugin
export default {"notification":"notification--257St","error":"error--2YKNQ","success":"success--1FiaA","span":"span--v_8tq","wrapper":"wrapper--yh4hI","text":"text--1TyXi"};